import React from 'react';
import { Col, Grid, Row, Tab, Tabs } from 'react-bootstrap';
import KaplanHistoryUpload from './kaplan-history-upload';
import KaplanUpload from './kaplan-upload';

/**
 * Kaplan upload mode for different kaplan activity reports.
 */
export const kaplanHistoryUploadMode = {
  modePre2022: 'pre-2022',
  mode2022: '2022',
}

const CpdPoint = () => {
  return <div className='base-layout'>
    <section className='layout--header'>
      <Grid>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h1>Kaplan Import</h1>
          </Col>
        </Row>
      </Grid>
    </section>
    <section id='section--admin-cpd-point' className='layout--section'>
      <Grid>
        <Row className='no-gutter sectionHeader'>
          <Tabs id='admin-kaplan-tabs'>
            <Tab
              eventKey={`history-${kaplanHistoryUploadMode.modePre2022}`}
              title={`History Upload (${kaplanHistoryUploadMode.modePre2022})`}
            >
              <KaplanHistoryUpload mode={kaplanHistoryUploadMode.modePre2022}/>
            </Tab>
            <Tab
              eventKey={`history-${kaplanHistoryUploadMode.mode2022}`}
              title={`History Upload (${kaplanHistoryUploadMode.mode2022})`}
            >
              <KaplanHistoryUpload mode={kaplanHistoryUploadMode.mode2022}/>
            </Tab>
            {
              false && <Tab eventKey='current' title='Current Year Upload'>
                <KaplanUpload />
              </Tab>
            }
          </Tabs>
        </Row>
      </Grid>
    </section>
  </div>
}

export default CpdPoint


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/cpd-point-portal/cpd-point.js